var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import prettyBytes from 'pretty-bytes';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import DeleteFileButton from './DeleteFileButton';
var nameComparator = function (a, b) { return a.name.localeCompare(b.name); };
var createdByComparator = function (a, b) {
    if (!a.createdBy && !b.createdBy) {
        return 0;
    }
    else if (!a.createdBy) {
        return 1;
    }
    else if (!b.createdBy) {
        return -1;
    }
    return a.createdBy.localeCompare(b.createdBy);
};
var createdDateComparator = function (a, b) {
    if (!a.createdDate && !b.createdDate) {
        return 0;
    }
    else if (!a.createdDate) {
        return 1;
    }
    else if (!b.createdDate) {
        return -1;
    }
    return new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime();
};
var sizeComparator = function (a, b) {
    if (typeof a.size === 'undefined' || typeof b.size === 'undefined') {
        return 0;
    }
    else if (typeof a.size === 'undefined') {
        return 1;
    }
    else if (typeof b.size === 'undefined') {
        return -1;
    }
    return a.size - b.size;
};
var negationComparator = function (comparator) {
    return function (a, b) {
        return -comparator(a, b);
    };
};
var comparators = {
    createdBy: createdByComparator,
    createdDate: createdDateComparator,
    name: nameComparator,
    size: sizeComparator
};
var DataSourceFileList = function (_a) {
    var files = _a.files, handleDeleteFile = _a.handleDeleteFile, buildDownloadUrl = _a.buildDownloadUrl;
    var _b = React.useState('asc'), order = _b[0], setOrder = _b[1];
    var _c = useState('name'), orderBy = _c[0], setOrderBy = _c[1];
    var handleRequestSort = function (_, column) {
        var isAsc = orderBy === column && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(column);
    };
    var createSortHandler = function (column) {
        return function (event) {
            return handleRequestSort(event, column);
        };
    };
    var createHeader = function (column, label) { return (_jsx(TableCell, { sortDirection: orderBy === column ? order : false, children: _jsx(TableSortLabel, { active: orderBy === column, direction: orderBy === column ? order : 'asc', onClick: createSortHandler(column), children: label }) })); };
    var comparator = order === 'asc' ? comparators[orderBy] : negationComparator(comparators[orderBy]);
    var sortedFiles = __spreadArray([], files, true).sort(comparator);
    return (_jsx(TableContainer, { children: _jsxs(Table, { sx: { minWidth: 750 }, size: "small", children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [createHeader('name', 'Name'), createHeader('createdDate', 'Created date'), createHeader('createdBy', 'Created by'), createHeader('size', 'Size'), _jsx(TableCell, {})] }) }), _jsx(TableBody, { children: sortedFiles.map(function (file) { return (_jsxs(TableRow, { hover: true, children: [_jsx(TableCell, { children: _jsx(Link, { href: buildDownloadUrl(file.name), children: file.name }) }), _jsx(TableCell, { children: file.createdDate && new Date(file.createdDate).toLocaleString() }), _jsx(TableCell, { children: file.createdBy }), _jsx(TableCell, { children: file.size && prettyBytes(file.size) }), _jsx(TableCell, { align: "right", children: _jsx(DeleteFileButton, { file: file, deleteFile: handleDeleteFile }) })] }, file.name)); }) })] }) }));
};
export default DataSourceFileList;
